import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/sidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import LeadCategoryList from "./leadCategoryList";

const LeadCategory = () => {
    return (
        <div className="category-wrapper sidebar-menu-enable">
            <Helmet><title>Category</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <LeadCategoryList />
                </div>
            </div>
            
        </div>
    );
}

export default LeadCategory;